export default "__VITE_ASSET__2ec01835__"